import React from "react";

// Professional SVG logo for "الخيط الذهبي" (Golden Thread)
// Concept: A diamond/gem woven from continuous golden threads, framed by an
// elegant geometric ring — evoking marble polishing and refined craftsmanship.
export default function Logo({ size = 44, className = "" }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-label="الخيط الذهبي"
            role="img"
        >
            <defs>
                <linearGradient id="gt-gold" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#f5e28c" />
                    <stop offset="35%" stopColor="#e8c86a" />
                    <stop offset="65%" stopColor="#c9a961" />
                    <stop offset="100%" stopColor="#8a6d2b" />
                </linearGradient>
                <linearGradient id="gt-shine" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#fff8d6" stopOpacity="0" />
                    <stop offset="50%" stopColor="#ffffff" stopOpacity="0.85" />
                    <stop offset="100%" stopColor="#fff8d6" stopOpacity="0" />
                </linearGradient>
                <radialGradient id="gt-glow" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor="#fff2b8" stopOpacity="0.6" />
                    <stop offset="70%" stopColor="#c9a961" stopOpacity="0.1" />
                    <stop offset="100%" stopColor="#8a6d2b" stopOpacity="0" />
                </radialGradient>
                <filter id="gt-blur" x="-20%" y="-20%" width="140%" height="140%">
                    <feGaussianBlur stdDeviation="0.6" />
                </filter>
            </defs>

            {/* Soft ambient glow behind the mark */}
            <circle cx="50" cy="50" r="46" fill="url(#gt-glow)" />

            {/* Outer decorative ring — hand-drawn feel */}
            <circle
                cx="50"
                cy="50"
                r="44"
                fill="none"
                stroke="url(#gt-gold)"
                strokeWidth="1.2"
                strokeDasharray="0.8 3"
                opacity="0.75"
            />

            {/* Inner precision ring */}
            <circle
                cx="50"
                cy="50"
                r="38"
                fill="none"
                stroke="url(#gt-gold)"
                strokeWidth="0.7"
                opacity="0.55"
            />

            {/* Diamond silhouette — woven from four continuous threads */}
            <g stroke="url(#gt-gold)" strokeWidth="1.8" fill="none" strokeLinejoin="round" strokeLinecap="round">
                {/* Main diamond outline */}
                <path d="M50 18 L78 50 L50 82 L22 50 Z" />
                {/* Upper facet */}
                <path d="M50 18 L36 34 L50 50 L64 34 Z" opacity="0.9" />
                {/* Lower facet */}
                <path d="M50 82 L36 66 L50 50 L64 66 Z" opacity="0.9" />
                {/* Horizontal girdle */}
                <path d="M22 50 L36 34 M22 50 L36 66" opacity="0.6" />
                <path d="M78 50 L64 34 M78 50 L64 66" opacity="0.6" />
            </g>

            {/* Center brilliance sparkle */}
            <circle cx="50" cy="50" r="2.2" fill="#fff8d6" filter="url(#gt-blur)" />
            <circle cx="50" cy="50" r="1" fill="#ffffff" />

            {/* Subtle diagonal shine sweep across the diamond */}
            <path
                d="M50 18 L78 50 L50 82 L22 50 Z"
                fill="url(#gt-shine)"
                opacity="0.35"
            />

            {/* Four thread accent dots (compass points) */}
            <g fill="#e8c86a">
                <circle cx="50" cy="10" r="1.4" />
                <circle cx="90" cy="50" r="1.4" />
                <circle cx="50" cy="90" r="1.4" />
                <circle cx="10" cy="50" r="1.4" />
            </g>
        </svg>
    );
}
